import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { About } from '../components/About';
import { Services } from '../components/Services';
import { WhyChoose } from '../components/WhyChoose';
import { Industries } from '../components/Industries';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900 selection:bg-blue-100 selection:text-blue-900" data-id="element-229">
      <Header data-id="element-230" />
      <main data-id="element-231">
        <Hero data-id="element-232" />
        <About data-id="element-233" />
        <Services data-id="element-234" />
        <WhyChoose data-id="element-235" />
        <Industries data-id="element-236" />
        <Contact data-id="element-237" />
      </main>
      <Footer data-id="element-238" />
    </div>;
}